import React from 'react';
import { IComponent } from './types';

export interface IQosContextProps {
  /**
   * Name to represent the content that is wrapped by QosProvider
   */
  readonly name: string;
  /**
   * Register the component to as one of the required components of the QosProvider
   */
  readonly registerComponent: (component: IComponent) => void;
  /**
   * Report a QoS event when the component finished loading without any failure
   */
  readonly reportLoadComplete: (component: IComponent) => void;
  /**
   * Report a Qos event when the component failed to load. Call this method only when a fatal or unexpected error occurs that makes the component unusable
   */
  readonly reportFailure: (component: IComponent, error: unknown) => void;
  /**
   * Unregister the component by removing it from the required components of the QosProvider. This happens when the component is unmounted from the DOM
   */
  readonly unregisterComponent: (component: IComponent) => void;
}

export const QosContext = React.createContext<IQosContextProps | null>(null);
